'use client';
import useLocalStorage from 'use-local-storage';
import DesignerButton from '@/app/shared/buttons/DesignerButton';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function ContactUsPopup() {
  const [showPopup, setShowPopup] = useLocalStorage('showPopup', true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  const closePopup = (event: React.MouseEvent): void => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    setShowPopup(false);
  };

  const contactUsHandler = (event: React.MouseEvent, href: string): void => {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    setShowPopup(false);

    window.open(href, '_blank');
  };

  const content = (
    <div
      id='contactUsPopup'
      suppressHydrationWarning
      className={`flex isolate fixed flex-col px-4 h-auto rounded-lg bg-[color:var(--white,#ffffff)] bottom-8 gap-[var(--space-16,1rem)] grow-0 max-h-[275px] max-w-[400px] pb-[var(--space-24,1.5rem)] pt-[var(--space-24,1.5rem)] right-8 shadow-[0px_4px_12px_rgba(0,0,0,0.1)] z-[999999] max-sm:max-w-none max-sm:bottom-4 max-sm:left-1/2 max-sm:-translate-x-1/2 max-sm:right-auto ${
        !showPopup ? 'hidden' : ''
      } transition-opacity duration-300 ${
        !showPopup ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className='flex justify-between items-center'>
        <span className='font-medium text-[color:var(--black,#000000)] text-[length:var(--font-size-lg,1.125rem)]'>
          FIND YOUR FIT AND SAVE!
        </span>
        <button
          className='relative z-10 px-0.5 cursor-pointer border-[none] pb-[var(--space-8,0.5rem)] pt-[var(--space-8,0.5rem)] text-[color:var(--designer-black,#1a1a1a)]'
          aria-label='Close popup'
          type='button'
          onClick={closePopup}
        >
          ✕
        </button>
      </div>
      <p className='flex m-0 leading-[var(--line-height-normal,1.4)] text-[color:var(--gray-700,#333333)] text-[length:var(--font-size-base,1rem)]'>
        Discover our innovative modular recognition system combining
        flexibility, style, and affordability. Contact us now to find your
        perfect solution.
      </p>
      <DesignerButton
        text='Contact Us'
        variant='primary'
        size='medium'
        ariaLabel='Contact Us Button'
        type='button'
        href='/'
        className='box-border flex relative flex-col shrink-0 mt-5'
        onClick={(event) =>
          contactUsHandler(
            event,
            'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLJ2xW9rYsx1zNSDwLUD%2BpkJ5szBBw5p5051kFk2okCVFlOaMLQk80csa28t067tSq0bp6IgJRd4SYPc48Bavypil5iZ%2BfV8xw2ysiRB7FL2oPVsMd9xKVuYqQkQBIogAX1WJadBnUjyBShXwIDEqb%2B4AIwDBtaV08XZB3Zm4OvEGXU%3D&webInteractiveContentId=186860869222&portalId=7717262'
          )
        }
        outline={false}
        disabled={false}
      />
    </div>
  );

  if (!mounted) return null;

  return createPortal(content, document.body);
}
